import React, { useEffect, useState, useRef, memo } from "react";
import { VideoContainer, VideoControls } from "../styles/components/section";
import { VolumeOnIcon, VolumeOffIcon } from "../data/icons";
import { getDeviceInfo } from "../data/utils";

const VideoMux = ({ videoContent, muxvideo, articleData, playVideo }) => {
  const { autoplay, loop, hideControls } = videoContent;

  const [MuxVideo, setMuxVideo] = useState(null);
  const [hasMounted, setHasMounted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(playVideo);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const { isHSApp } = getDeviceInfo();

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !muxvideo || !hasMounted) return;
    const loadMuxVideo = async () => {
      try {
        const { default: MuxVideoComponent } = await import(
          "@mux/mux-video-react"
        );
        setMuxVideo(() => MuxVideoComponent);
      } catch (error) {
        console.error("Error loading MuxVideo:", error);
      }
    };
    loadMuxVideo();
  }, [muxvideo, hasMounted]);

  useEffect(() => {
    if (videoRef.current && playVideo) {
      const playPromise = videoRef.current.play?.();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.catch(err => {
          console.warn("Video playback failed:", err);
        });
      }
    }
  }, [playVideo]);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVideoClick = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <>
      {MuxVideo && muxvideo && (
        <VideoContainer>
          <MuxVideo
            ref={videoRef}
            onClick={handleVideoClick}
            style={{
              height: "100%",
              width: "100%",
              maxWidth: "100%",
            }}
            playbackId={muxvideo.video?.muxPlaybackId}
            metadata={{
              video_id: muxvideo.video?.muxPlaybackId,
              video_title: muxvideo.title || "Highsnobiety Video",
            }}
            streamType="on-demand"
            controls={false}
            poster={`https://image.mux.com/${muxvideo.video?.muxPlaybackId}/thumbnail.jpg?time=0.001`}
            autoPlay={autoplay || false}
            muted={true}
            loop={loop}
            playsInline
            webkit-playsinline="true"
            x-webkit-airplay="allow"
            disablePictureInPicture
            disableRemotePlayback
          />

          {!hideControls && (
            <VideoControls onClick={toggleMute} $isHSApp={isHSApp}>
              {isMuted ? (
                <VolumeOffIcon colors={articleData?.colors?.primary} />
              ) : (
                <VolumeOnIcon colors={articleData?.colors?.primary} />
              )}
            </VideoControls>
          )}
        </VideoContainer>
      )}
    </>
  );
};

export default memo(VideoMux);
